module.exports = __webpack_public_path__ + "assets/80349724fe87aeb3ddc8d8a2596c96aa.png";